module.exports = __webpack_public_path__ + "static/media/spoonerism-task (20).232674c5.mp3";